<template>
  <div class="space-y-6">
    <div class="space-y-4">
      <!-- Site Label -->
      <div class="space-y-2">
        <label class="text-[14px] font-bold text-foreground">Label*</label>
        <input
          :value="item.label"
          @input="update('label', $event.target.value)"
          type="text"
          placeholder="e.g. Portfolio, GitHub, LinkedIn"
          class="w-full px-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
          required
        />
      </div>

      <!-- URL -->
      <div class="space-y-2">
        <label class="text-[14px] font-bold text-foreground">URL*</label>
        <div class="relative group">
          <LinkIcon
            class="absolute left-5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground/50"
          />
          <input
            :value="item.url"
            @input="update('url', $event.target.value)"
            type="url"
            placeholder="https://..."
            class="w-full pl-12 pr-5 py-3 rounded-xl border border-border/50 bg-white dark:bg-muted/10 text-foreground outline-none focus:ring-1 focus:ring-primary/20 transition-all"
            required
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link as LinkIcon } from "lucide-vue-next";

export default {
  name: "WebsitesForm",
  components: {
    LinkIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    update(key, value) {
      this.$emit("update", { [key]: value });
    },
  },
};
</script>
